(ns rothko.theme.manatee.hideable-container
  (:require [garden.color :refer [darken]]
            [garden.units :refer [em]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def main
  {:default
   {:hidden-outline-color (:blue-light colours)
    :hidden-outline-width (em 0.15)
    :hidden-outline-style :dashed
    :hidden-outline-offset (em 0.1)
    :hidden-outline-color--hover (darken (:blue-light colours) 15)
    :hidden-cursor--hover :pointer}})
